// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tRv0","col":"styles_col__1LTY1"};